import { createContext } from 'react';
export var MenuContext = /*#__PURE__*/createContext({});